import { useState } from 'react';
import { ChevronDown, EyeOff } from 'lucide-react';

/**
 * Collapsible tray that holds the suggestion cards the retailer has hidden
 * (NEA-5765). Renders nothing when empty.
 */
export function HiddenTray({ count, children }) {
	const [open, setOpen] = useState(false);
	if (count <= 0) return null;
	return (
		<div className="pt-1">
			<button
				type="button"
				onClick={() => setOpen((v) => !v)}
				aria-expanded={open}
				className="inline-flex w-full items-center justify-between gap-2 rounded-xl border border-dashed border-border bg-accent/30 px-4 py-2.5 text-sm font-semibold text-muted-foreground transition hover:bg-accent hover:text-foreground"
			>
				<span className="inline-flex items-center gap-2">
					<EyeOff className="h-3.5 w-3.5" />
					{count} hidden suggestion{count === 1 ? '' : 's'}
				</span>
				<span className="inline-flex items-center gap-1">
					{open ? 'Hide' : 'Show'}
					<ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
				</span>
			</button>
			{open ? <div className="mt-3 space-y-3 opacity-80">{children}</div> : null}
		</div>
	);
}
